import { render, staticRenderFns } from "./ConservationAgriculture.vue?vue&type=template&id=2864f2d7&scoped=true&"
import script from "./ConservationAgriculture.vue?vue&type=script&lang=js&"
export * from "./ConservationAgriculture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2864f2d7",
  null
  
)

export default component.exports